import React, { useState } from "react";
import SelectAsync from 'react-select/async';
import Select from 'react-select';

import { request } from "../../utils/request";
import Loader from "../general/Loader";
import { getVendedoresForDropdown, toast } from "../../utils/helpers";
import { apiRequest } from "../../hooks/apiRequest";
import dayjs from "dayjs";

const ComisionesForm = ({getNominas, toggle}) => {
    const [saving, setSaving] = useState(false);
    const [nombre, setNombre] = useState();
    const [diasVencimiento, setDiasVencimiento] = useState(0);
    const [limiteVencimiento, setLimiteVencimiento] = useState(false);
    const [categorias, setCategorias] = useState([
        {
            id: new Date().getTime(),
            nombre: '',
            porcentaje: '',
        }
    ]);

    const [state, setState] = useState({
        errors: {},
        tipo_comision: '',
        tipo: '',
        porcentaje: '',
        generar_por: 'grupo',
        fecha_cierre: '',
        fecha_inicio: '',
    });

    const addCategoria = () => {
        setCategorias([...categorias, {
            id: new Date().getTime(),
            nombre: '',
            porcentaje: '',
        }]);
    };

    const removeCategoria = (id) => {
        setCategorias(categorias.filter(categoria => categoria.id !== id));
    };

    const onInputChange = async (value, name) => {
        const newState = {
            ...state,
            [name]: value,
        }
        await setState(newState);
        const nombre = `Comisiones ${newState?.tipo_comision} ${dayjs(newState.fecha_inicio).format('MMM YYYY')}`
        setNombre(nombre);
    }

    const createNomina = async (event) => {
        event.preventDefault();
        setSaving(true);

        const data = new FormData(event.target);
        const response = await apiRequest(data, 'nominas/comisiones');

        if (response.success) {
            getNominas();
            toggle();
        }

        if (response.code === 422) {
            if (response.data.message) {
                setState({ ...state, errors: response.data.message });
                toast('No se ha podido generar la nomina. Favor revisar campos.', 'error');
            } else {
                toast(response.data, 'error');
            }
        }

        setSaving(false);
    };

    const getOptions = async (callback, url = null, label = 'nombre', value = 'id') => {
        const response = await request(url);
        if (response.data) {
            callback([
                {value: 'todos', label: 'Todos'},
                ...response.data.map(item => ({
                    value: item[value], label: item[label]
                }))
            ]);
        }
    };


    const { errors, tipo_comision, fecha_cierre, fecha_inicio, porcentaje } = state;

    return (
        <form method='post' onSubmit={createNomina}>
            <div className='popup__header'>Cálculo de Comisión</div>
            <div className='popup__body'>
                <div>
                    <input type="hidden" name="tipo" value='COMISIONES' />

                    <div className='row form-group'>
                        <div className='col col-md-5'>
                            <label className='label form-control-label'>
                                Vendedores:
                            </label>
                        </div>
                        <div className='col col-md-7'>
                            <SelectAsync
                                isMulti
                                isClearable
                                cacheOptions
                                defaultOptions
                                key="empleados"
                                name='empleados[]'
                                menuPosition="fixed"
                                menuPlacement="auto"
                                loadOptions={(e, callback) => {
                                    getOptions(callback, 'empleados?limit=10&vendedores=true&buscar='+e, 'nombreCompleto');
                                }}
                            />
                            {errors.empleado_id && (
                                <small className='help-blockParams form-Text'>
                                    {errors.empleado_id[0]}
                                </small>
                            )}
                        </div>
                    </div>

                    <div className='row form-group'>
                        <div className='col col-md-5'>
                            <label className='label form-control-label'>
                                Fecha de Inicio:
                            </label>
                        </div>
                        <div className='col col-md-7'>
                            <input
                                type='date'
                                className='text-input form-control'
                                id='fecha_inicio'
                                name='fecha_inicio'
                                onChange={e => onInputChange(e.target.value, 'fecha_inicio')}
                                value={fecha_inicio}
                            />
                            {errors.fecha_inicio && (
                                <small className='help-blockParams form-Text'>
                                    {errors.fecha_inicio[0]}
                                </small>
                            )}
                        </div>
                    </div>

                    <div className='row form-group'>
                        <div className='col col-md-5'>
                            <label className='label form-control-label'>
                                Fecha de Cierre:
                            </label>
                        </div>
                        <div className='col col-md-7'>
                            <input
                                type='date'
                                className='text-input form-control'
                                id='fecha_cierre'
                                name='fecha_cierre'
                                onChange={e => onInputChange(e.target.value, 'fecha_cierre')}
                                value={fecha_cierre}
                            />
                            {errors.fecha_cierre && (
                                <small className='help-blockParams form-Text'>
                                    {errors.fecha_cierre[0]}
                                </small>
                            )}
                        </div>
                    </div>

                    <hr />

                    <div className="row m-t-10">
                        <div className="col-md-6">
                            <div className='form-group'>
                                <label className='label form-control-label m-b-5'>
                                    Tipo Comisión:
                                </label>
                                <Select
                                    isClearable
                                    key="tipo_comision"
                                    name='tipo_comision'
                                    menuPosition="fixed"
                                    menuPlacement="auto"
                                    onChange={e => onInputChange(e?.value, 'tipo_comision')}
                                    options={[
                                        {label: 'Categoría de Productos', value: 'Categorías'},
                                        {label: 'Ventas Sin Impuestos', value: 'Ventas Sin Impuestos'},
                                        {label: 'Ventas + Impuestos', value: 'Ventas + Impuestos'},
                                        {label: 'Cobros Sin Impuestos', value: 'Cobros Sin Impuestos'},
                                        {label: 'Cobros (NCF+Proforma)', value: 'Cobros (NCF+Proforma)'},
                                        {label: 'Cobros (Solo Proforma)', value: 'Cobros (Solo Proforma)'},
                                    ]}
                                />
                                <input type="hidden" name="settings[tipo_comision]" value={tipo_comision} />
                                {errors.tipo_comision && (
                                    <small className='help-blockParams form-Text'>
                                        {errors.tipo_comision[0]}
                                    </small>
                                )}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className='form-group'>
                                <label className='label form-control-label m-b-5'>
                                    {tipo_comision === 'Categorías' ? '% General:' : 'Porcentaje %:'}
                                </label>
                                <input
                                    type='number'
                                    step='0.01'
                                    className='text-input form-control'
                                    id='porcentaje'
                                    name='porcentaje'
                                    onChange={e => onInputChange(e.target.value, 'porcentaje')}
                                    value={porcentaje}
                                />
                                {errors.porcentaje && (
                                    <small className='help-blockParams form-Text'>
                                        {errors.porcentaje[0]}
                                    </small>
                                )}
                            </div>
                        </div>
                    </div>

                    {tipo_comision === 'Categorías' && (
                        <>
                            <div className='row form-group'>
                                <div className="col-5">
                                    <label className='switch switch-3d switch-success mr-3'>
                                        <input
                                            type='checkbox'
                                            className='switch-input'
                                            value='true'
                                            checked={limiteVencimiento}
                                            onChange={(e) => setLimiteVencimiento(e.target.checked)}
                                        />
                                        <span className='switch-label'></span>
                                        <span className='switch-handle' />
                                    </label>
                                    <span className="mt-1" style={{display: 'inline-block'}}>Excluir Vencidas</span>
                                </div>
                                {limiteVencimiento && (
                                    <div className="col row">
                                        <div className='col col-md-6'>
                                            <label className='label form-control-label mt-1'>
                                                Días Vencimiento:
                                            </label>
                                        </div>
                                        <div className='col col-md-6'>
                                            <input
                                                type='number'
                                                step="0.01"
                                                className='text-input form-control'
                                                id='dias_vencimiento'
                                                name='settings[dias_vencimiento]'
                                            />
                                            {errors.dias_vencimiento && (
                                                <small className='help-blockParams form-Text'>
                                                    {errors.dias_vencimiento[0]}
                                                </small>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className='row form-group'>
                                <div className="col">
                                    <label className='switch switch-3d switch-success mr-3'>
                                        <input
                                            type='checkbox'
                                            className='switch-input'
                                            name='settings[incluir_impuestos]'
                                            value='true'
                                        />
                                        <span className='switch-label'></span>
                                        <span className='switch-handle' />
                                    </label>
                                    <span className="mt-1" style={{display: 'inline-block'}}>Incluir Impuestos</span>
                                </div>
                                <div className="col">
                                    <label className='switch switch-3d switch-success mr-3'>
                                        <input
                                            type='checkbox'
                                            className='switch-input'
                                            name='settings[ventas]'
                                            value='true'
                                        />
                                        <span className='switch-label'></span>
                                        <span className='switch-handle' />
                                    </label>
                                    <span className="mt-1" style={{display: 'inline-block'}}>Comisión por Ventas</span>
                                </div>
                            </div>

                            <hr />

                            <fieldset className='fieldset'>
                                <legend>Categorías de Productos</legend>
                                {categorias.map((categoria, index) => (
                                    <div key={categoria.id} className='row form-group align-items-end'>
                                        <div className='col-md-8'>
                                            <label className='label form-control-label'>
                                                Categoría:
                                            </label>
                                            <SelectAsync
                                                cacheOptions
                                                defaultOptions
                                                key={`settings[categorias][${index}]`}
                                                name={`settings[categorias][${index}][id]`}
                                                menuPosition="fixed"
                                                menuPlacement="auto"
                                                loadOptions={(e, callback) => {
                                                    getOptions(callback, 'grupos?limit=10&buscar='+e);
                                                }}
                                            />
                                        </div>
                                        <div className='col'>
                                            <label className='label form-control-label'>
                                                Porcentaje %:
                                            </label>
                                            <div className="flex">
                                                <input
                                                    type='number'
                                                    className='text-input form-control'
                                                    step="0.01"
                                                    name={`settings[categorias][${index}][porcentaje]`}
                                                />
                                                <button type='button' className='btn btn-plain btn-sm m-t-5 ml-2' onClick={() => removeCategoria(categoria.id)}>
                                                    <i className='fa fa-trash'></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <div className="text-right">
                                    <button type='button' className='btn btn-plain btn-sm m-b-10' onClick={addCategoria}>
                                        <i className='fa fa-plus'></i> Agregar Categoría
                                    </button>
                                </div>
                            </fieldset>
                        </>
                    )}

                    <div className='row form-group'>
                        <div className='col'>
                            <label className='label form-control-label'>
                                Nombre:
                            </label>
                            <input
                                type='text'
                                className='text-input form-control'
                                id='nombre'
                                name='nombre'
                                onChange={e => setNombre(e.target.value)}
                                value={nombre}
                            />
                            {errors.nombre && (
                                <small className='help-blockParams form-Text'>
                                    {errors.nombre[0]}
                                </small>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className='popup__footer'>
                <button
                    type='button'
                    onClick={toggle}
                    className='btn btn-plain'>
                    Cancelar
                </button>
                {saving ? (
                    <Loader type='small' />
                ) : (
                    <button type='submit' className='btn btn-primary'>
                        Crear
                    </button>
                )}
            </div>
        </form>
    );
}

export default ComisionesForm;
